import { useState, useEffect } from "react";
import {
  processFileUpload,
  registerBeneficiarios,
  loadExistingBeneficiaryData,
  handleRegistrationConfirmation,
  handleStepReset,
} from "../utils/beneficiaryDataUtils";
import { showProcessingErrorAlert } from "../utils/alertUtils";

export const useBeneficiaryDataLoader = () => {
  const [file, setFile] = useState(null);
  const [beneficiarios, setBeneficiarios] = useState(false);
  const [beneficiaryData, setBeneficiaryData] = useState([]);
  const [isLoadingUpload, setIsLoadingUpload] = useState(false);
  const [isLoadingSend, setIsLoadingSend] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [showInvalidData, setShowInvalidData] = useState(false);
  const [invalidRecords, setInvalidRecords] = useState([]);

  useEffect(() => {
    loadExistingBeneficiaryData(setBeneficiaryData);
  }, []);

  const resetAllStates = () => {
    setFile(null);
    setBeneficiarios(false);
    setInvalidRecords([]);
    setShowInvalidData(false);
    setIsLoadingUpload(false);
    setIsLoadingSend(false);
    setCurrentStep(1);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    setIsLoadingUpload(true);
    setCurrentStep(2);

    try {
      await processFileUpload(
        file,
        setBeneficiarios,
        setInvalidRecords,
        setShowInvalidData
      );
      setIsLoadingUpload(false);
      setCurrentStep(3);
    } catch (error) {
      setIsLoadingUpload(false);
      setCurrentStep(1);

      if (error.message !== "No file selected") {
        await showProcessingErrorAlert();
      }
    }
  };

  const handlePostBeneficiarios = () => {
    setIsLoadingSend(true);
    setCurrentStep(4);

    registerBeneficiarios(beneficiarios)
      .then(() => {
        setIsLoadingSend(false);
      })
      .catch(() => {
        setIsLoadingSend(false);
        setCurrentStep(3);
      });
  };

  const handleClickConfirm = (event) => {
    event.preventDefault();
    handleRegistrationConfirmation(beneficiaryData, handlePostBeneficiarios);
  };

  const resetToFirstStep = () => {
    handleStepReset(currentStep, beneficiarios, resetAllStates);
  };

  return {
    file,
    beneficiarios,
    beneficiaryData,
    isLoadingUpload,
    isLoadingSend,
    currentStep,
    showInvalidData,
    invalidRecords,
    setFile,
    setShowInvalidData,
    handleSubmit,
    handleClickConfirm,
    resetToFirstStep,
  };
};
